import React, { PropsWithChildren } from 'react';
import styles from './InputGroupContent.module.css';

/**
 * Wrapper for Bootstrap input group content. Normally the prepend / append elements work together
 * only with .formControl element. Use this wrapper if you would like to put anything else to the
 * InputGroup.
 *
 * Usage:
 * <InputGroup>
 *  <Prepend>@</Prepend>
 *  <InputGroupContent>YourContent</InputGroupContent>
 * </InputGroup>
 * @constructor
 */
const InputGroupContent = (props: PropsWithChildren<any>) => {
  return <div className={styles.content}>{props.children}</div>;
};

export default InputGroupContent;
